import { t } from "ttag";

import { Banner } from "metabase/common/components/Banner";
import { Text } from "metabase/ui";

// patch:gowdham:unlock-enterprise - Never render dev mode banner
export const DevModeBanner = () => {
  return null;
};
